import { getLayoutMaxWidth } from '@/_shared/tools/layout.js';
import { makeStyles, tokens } from '@fluentui/react-components';

export const useStyles = makeStyles({
    page: {
        ...getLayoutMaxWidth(true),
        containerType: 'inline-size',
        display: 'grid',
        gridTemplateColumns: 'repeat(2, 1fr)',
        gap: tokens.spacingVerticalXL,
        overflow: 'auto',
        padding: tokens.spacingHorizontalSNudge,
    },
});
